unit Hlavny;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.JSON,
  WEBLib.REST, WEBLib.Buttons;

type
  TfHlavny = class(TForm)
    btnBiologia: TSpeedButton;
    btnChemia: TSpeedButton;
    btnTestBio: TSpeedButton;
    btnTestChe: TSpeedButton;
    chkOkruh1: TCheckBox;
    chkOkruh2: TCheckBox;
    chkOkruh3: TCheckBox;
    chkOkruh4: TCheckBox;
    chkOkruh5: TCheckBox;
    chkOkruh6: TCheckBox;
    chkOkruh7: TCheckBox;
    chkOkruh8: TCheckBox;
    chkOkruh9: TCheckBox;
    chkOkruh10: TCheckBox;
    chkOkruh11: TCheckBox;
    chkOkruh12: TCheckBox;
    chkOkruh13: TCheckBox;
    chkOkruh14: TCheckBox;
    chkOkruh15: TCheckBox;
    edtOd: TEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    edtDo: TEdit;
    btnVynulovatRozsah: TSpeedButton;
    btnOpakovatBio: TSpeedButton;
    btnOpakovatChem: TSpeedButton;
    rgPocetOdpovedi: TRadioGroup;
    [async]
    procedure btnBiologiaClick(Sender: TObject); async;
    [async]
    procedure btnChemiaClick(Sender: TObject); async;
    [async]
    procedure btnTestBioClick(Sender: TObject); async;
    [async]
    procedure btnTestCheClick(Sender: TObject); async;
    procedure btnVynulovatRozsahClick(Sender: TObject);
    procedure edtOdKeyPress(Sender: TObject; var Key: Char);
    procedure edtDoKeyPress(Sender: TObject; var Key: Char);
    procedure btnOpakovatBioClick(Sender: TObject);
    procedure btnOpakovatChemClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
   FChybneOtazky: String;
    [async]
   procedure SpustiOpravneKolo(const APredmet: string; AButtonToHide: TSpeedButton); async;
  protected procedure LoadDFMValues; override; end;

var
  fHlavny: TfHlavny;

implementation

{$R *.dfm}

uses uSpravaOtazok, uStudentTest, uVysledkyTestu;

procedure TfHlavny.btnBiologiaClick(Sender: TObject);
var
  FormSprava: TfSpravaOtazok;
begin
  FormSprava := TfSpravaOtazok.Create(Self);
  FormSprava.VybranyPredmet := 'Biologia'; // Odovzdáme informáciu o predmete
  FormSprava.Popup := False;
  FormSprava.Border := fbNone;
  await(TfSpravaOtazok, FormSprava.Load);
  await(TModalResult, FormSprava.Execute);
  FormSprava.Free;



{    Uzivatelia := TfUzivatelia.Create(Self);
  Uzivatelia.Popup := False;
  Uzivatelia.Border := fbNone;
  Uzivatelia.left := 1000;
  Uzivatelia.top := 0;
//  newform.ShowModal();
 // newform.free;
  await( TfUzivatelia, Uzivatelia.Load );
  await(TModalResult, Uzivatelia.Execute);
  Uzivatelia.free;
 }

end;

procedure TfHlavny.btnChemiaClick(Sender: TObject);
var
  FormSprava: TfSpravaOtazok;
begin
  FormSprava := TfSpravaOtazok.Create(Self);
  FormSprava.VybranyPredmet := 'Chemia';
  FormSprava.Popup := False;
  FormSprava.Border := fbNone;
  await(TfSpravaOtazok, FormSprava.Load);
  await(TModalResult, FormSprava.Execute);
  FormSprava.Free;

end;

procedure TfHlavny.btnTestCheClick(Sender: TObject);
var
  Req: THttpRequest;
  res: TJSXMLHttpRequest;
  JS: TJSONObject;
  JA: TJSONArray;
  CistyJsonText, FilterPayload: string;
  JSONRes: TJSONObject;
  NewTestID: Integer;
  VstupOd, VstupDo: Integer;
  ZvolenaVolba: TModalResult;
begin
  // 1. Prečítame čísla z editov, ak tam niečo je
  if edtOd.Text <> '' then VstupOd := StrToIntDef(edtOd.Text, 0) else VstupOd := 0;
  if edtDo.Text <> '' then VstupDo := StrToIntDef(edtDo.Text, 0) else VstupDo := 0;
  // 🚀 ZMENA PODMIENKY: Kontrolu začiarknutých okruhov robíme IBA vtedy, ak študent NEZADAL číselný rozsah!
  if (VstupOd = 0) and (VstupDo = 0) then
  begin
    if not (chkOkruh1.Checked or chkOkruh2.Checked or chkOkruh3.Checked or
            chkOkruh4.Checked or chkOkruh5.Checked or chkOkruh6.Checked or
            chkOkruh7.Checked or chkOkruh8.Checked or chkOkruh9.Checked or
            chkOkruh10.Checked or chkOkruh11.Checked or chkOkruh12.Checked or
            chkOkruh13.Checked or chkOkruh14.Checked or chkOkruh15.Checked) then
    begin
      ShowMessage('Chyba: Musíte vybrať minimálne jeden okruh alebo zadať rozsah otázok Od - Do!');
      Exit;
    end;
  end;




  JS := TJSONObject.Create;
  JS.AddPair('student_id', 1); // Ak máš ID v edite, tak napr. StrToInt(edID.Text)
  JS.AddPair('predmet', 'Chemia');

  // 🚀 NOVINKA: Pribalíme čísla rozsahu priamo do hlavného JSONu
  JS.AddPair('od_cisla', VstupOd);
  JS.AddPair('do_cisla', VstupDo);

  if rgPocetOdpovedi.ItemIndex >= 0 then
    JS.AddPair('pocet_odpovedi', rgPocetOdpovedi.ItemIndex + 2)
  else
    JS.AddPair('pocet_odpovedi', 8); // Bezpečná poistka, ak by nebolo kliknuté nič


  JA := TJSONArray.Create;
  if chkOkruh1.Checked then JA.Add('001-100');
  if chkOkruh2.Checked then JA.Add('101-200');
  if chkOkruh3.Checked then JA.Add('201-300');
  if chkOkruh4.Checked then JA.Add('301-400');
  if chkOkruh5.Checked then JA.Add('401-500');
  if chkOkruh6.Checked then JA.Add('501-600');
  if chkOkruh7.Checked then JA.Add('601-700');
  if chkOkruh8.Checked then JA.Add('701-800');
  if chkOkruh9.Checked then JA.Add('801-900');
  if chkOkruh10.Checked then JA.Add('901-1000');
  if chkOkruh11.Checked then JA.Add('1001-1100');
  if chkOkruh12.Checked then JA.Add('1101-1200');
  if chkOkruh13.Checked then JA.Add('1201-1300');
  if chkOkruh14.Checked then JA.Add('1301-1400');
  if chkOkruh15.Checked then JA.Add('1401-1500');
  JS.AddPair('okruhy', JA);

  FilterPayload := JS.ToString;

  JS.Free;

  Req := THttpRequest.Create(nil);
  try
    Req.Command := httpPOST;
    Req.URL := 'http://' + window.location.hostname + ':8080/inicializujtest';
    asm
      var utf8Bytes = encodeURIComponent(FilterPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) {
          return String.fromCharCode('0x' + p1);
      });
      Req.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, Req.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      asm
        var binaryString = atob(res.responseText);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
      try
        NewTestID := StrToInt(JSONRes.Values['test_id'].Value);
        // Dynamické načítanie formulára pre Chémiu
        fStudentTest := TfStudentTest.Create(Self);
        try
          fStudentTest.Popup := False;
          fStudentTest.Border := fbNone;
          await(TfStudentTest, fStudentTest.Load);
          // 🚀 POISTKA PRI ŠTARTE: Ak server posiela v inicializácii aj celkový počet otázok,
          // priradíme ho hneď tu do vnútra formulára:
          if JSONRes.Values['max_otazok'] <> nil then
            fStudentTest.FMaxOtazok := StrToInt(JSONRes.Values['max_otazok'].Value)
          else
            fStudentTest.FMaxOtazok := 0; // Prípadne sem daj natvrdo 100, ak vieš, že test má vždy 100 otázok
          fStudentTest.OtvorTest(NewTestID, 1);
          await(TModalResult, fStudentTest.Execute);
        finally
          if FChybneOtazky <> '' then
          begin
                // 🚀 ASYNCHRÓNNE VYHODÍME OKNO S TROMI GOMBÍKMI:
                // mtConfirmation hodí peknú ikonu, [mbYes, mbNo, mbCancel] vyrobí 3 gombíky
  // 🚀 JEDINÝ SPRÁVNY ASYNCHRÓNNY ZÁPIS PRE TMS WEB CORE:
  ZvolenaVolba := await(MessageDlgAsync(
    'Čo chcete urobiť ?'#13#10'👉 PONECHAŤ všetky doterajšie chybné (Kliknite na [ÁNO / YES])'#13#10'👉 ZMENIŤ na nové chybné otázky (Kliknite na [NIE / NO])'#13#10'❌ ZRUŠIŤ akciu (Kliknite na [ZRUŠIŤ / CANCEL])',
    mtConfirmation, [mbYes, mbNo, mbCancel]));

//                  ZvolenaVolba := await(TModalResult, MessageDlg('Opakovať všetky chybné alebo len posledné chybné alebo neopakujeme ?',
//                                       mtConfirmation, [mbYes, mbNo, mbCancel], 0));
                // 🎯 VYHODNOTENIE, NA ČO ŠTUDENT KLIKOL:
               case ZvolenaVolba of
                mrYes:
                begin
                // 🟢 PONECHAŤ (Študent klikol na "Yes" / Áno)
                //ShowMessage('Zvolili ste: Ponechať pôvodné otázky.');
                // ... sem vložíš tvoj kód pre ponechanie ...
                end;
                mrNo:
                begin
                // 🔵 ZMENIŤ (Študent klikol na "No" / Nie)
                //ShowMessage('Zvolili ste: Zmeniť otázky.');
                FChybneOtazky := fStudentTest.textChyb;
                end;
                mrCancel:
                begin
                // 🔴 ZRUŠIŤ (Študent klikol na "Cancel" / Zrušiť)
                //ShowMessage('Akcia bola zrušená.');
                FChybneOtazky := ''; // Úplne vyskočíme z procedúry, nič sa nedeje
                end;
               end;

          end else FChybneOtazky := fStudentTest.textChyb;


          fStudentTest.Free;
        end;

           btnOpakovatBio.Visible := False;
           btnOpakovatChem.Visible := False;
          if FChybneOtazky <> '' then
           btnOpakovatChem.Visible := True;




      finally
        JSONRes.Free;
      end;
    end;
  finally
    Req.Free;
  end;
end;
procedure TfHlavny.btnVynulovatRozsahClick(Sender: TObject);
begin
  edtOd.Text := '';
  edtDo.Text := '';
end;

procedure TfHlavny.btnOpakovatBioClick(Sender: TObject);
begin
SpustiOpravneKolo('Biologia', btnOpakovatBio);
end;

procedure TfHlavny.btnOpakovatChemClick(Sender: TObject);
begin
  SpustiOpravneKolo('Chemia', btnOpakovatChem);
end;

procedure TfHlavny.edtDoKeyPress(Sender: TObject; var Key: Char);
begin
  // Povolíme iba čísla (0-9) a Backspace (#8) pre mazanie
  if not (Key in ['0'..'9', #8]) then
  begin
    Key := #0; // Úplne zahodí stlačený kláves, písmeno sa vôbec nezapíše
  end;
end;

procedure TfHlavny.edtOdKeyPress(Sender: TObject; var Key: Char);
begin
  // Povolíme iba čísla (0-9) a Backspace (#8) pre mazanie
  if not (Key in ['0'..'9', #8]) then
  begin
    Key := #0; // Úplne zahodí stlačený kláves, písmeno sa vôbec nezapíše
  end;
end;

procedure TfHlavny.btnTestBioClick(Sender: TObject);
var
  Req: THttpRequest;
  res: TJSXMLHttpRequest;
  JS: TJSONObject;
  JA: TJSONArray;
  CistyJsonText, FilterPayload: string;
  JSONRes: TJSONObject;
  NewTestID: Integer;
  VstupOd, VstupDo: Integer;
  ZvolenaVolba: TModalResult;
begin
  // 1. Prečítame čísla z editov, ak tam niečo je
  if edtOd.Text <> '' then VstupOd := StrToIntDef(edtOd.Text, 0) else VstupOd := 0;
  if edtDo.Text <> '' then VstupDo := StrToIntDef(edtDo.Text, 0) else VstupDo := 0;
  // 🚀 ZMENA PODMIENKY: Kontrolu začiarknutých okruhov robíme IBA vtedy, ak študent NEZADAL číselný rozsah!
  if (VstupOd = 0) and (VstupDo = 0) then
  begin
    if not (chkOkruh1.Checked or chkOkruh2.Checked or chkOkruh3.Checked or
            chkOkruh4.Checked or chkOkruh5.Checked or chkOkruh6.Checked or
            chkOkruh7.Checked or chkOkruh8.Checked or chkOkruh9.Checked or
            chkOkruh10.Checked or chkOkruh11.Checked or chkOkruh12.Checked or
            chkOkruh13.Checked or chkOkruh14.Checked or chkOkruh15.Checked) then
    begin
      ShowMessage('Chyba: Musíte vybrať minimálne jeden okruh alebo zadať rozsah otázok Od - Do!');
      Exit;
    end;
  end;




  JS := TJSONObject.Create;
  JS.AddPair('student_id', 1); // Ak máš ID v edite, tak napr. StrToInt(edID.Text)
  JS.AddPair('predmet', 'Biologia');

  // 🚀 NOVINKA: Pribalíme čísla rozsahu priamo do hlavného JSONu
  JS.AddPair('od_cisla', VstupOd);
  JS.AddPair('do_cisla', VstupDo);

  if rgPocetOdpovedi.ItemIndex >= 0 then
    JS.AddPair('pocet_odpovedi', rgPocetOdpovedi.ItemIndex + 2)
  else
    JS.AddPair('pocet_odpovedi', 8); // Bezpečná poistka, ak by nebolo kliknuté nič



  JA := TJSONArray.Create;
  if chkOkruh1.Checked then JA.Add('001-100');
  if chkOkruh2.Checked then JA.Add('101-200');
  if chkOkruh3.Checked then JA.Add('201-300');
  if chkOkruh4.Checked then JA.Add('301-400');
  if chkOkruh5.Checked then JA.Add('401-500');
  if chkOkruh6.Checked then JA.Add('501-600');
  if chkOkruh7.Checked then JA.Add('601-700');
  if chkOkruh8.Checked then JA.Add('701-800');
  if chkOkruh9.Checked then JA.Add('801-900');
  if chkOkruh10.Checked then JA.Add('901-1000');
  if chkOkruh11.Checked then JA.Add('1001-1100');
  if chkOkruh12.Checked then JA.Add('1101-1200');
  if chkOkruh13.Checked then JA.Add('1201-1300');
  if chkOkruh14.Checked then JA.Add('1301-1400');
  if chkOkruh15.Checked then JA.Add('1401-1500');
  JS.AddPair('okruhy', JA);

  FilterPayload := JS.ToString;

  JS.Free;

  Req := THttpRequest.Create(nil);
  try
    Req.Command := httpPOST;
    Req.URL := 'http://' + window.location.hostname + ':8080/inicializujtest';
    asm
      var utf8Bytes = encodeURIComponent(FilterPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) {
          return String.fromCharCode('0x' + p1);
      });
      Req.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, Req.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      asm
        var binaryString = atob(res.responseText);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
      try
        NewTestID := StrToInt(JSONRes.Values['test_id'].Value);
        // Dynamické načítanie formulára pre Chémiu
        fStudentTest := TfStudentTest.Create(Self);
        try
          fStudentTest.Popup := False;
          fStudentTest.Border := fbNone;
          await(TfStudentTest, fStudentTest.Load);
          // 🚀 POISTKA PRI ŠTARTE: Ak server posiela v inicializácii aj celkový počet otázok,
          // priradíme ho hneď tu do vnútra formulára:
          if JSONRes.Values['max_otazok'] <> nil then
            fStudentTest.FMaxOtazok := StrToInt(JSONRes.Values['max_otazok'].Value)
          else
            fStudentTest.FMaxOtazok := 0; // Prípadne sem daj natvrdo 100, ak vieš, že test má vždy 100 otázok
          fStudentTest.OtvorTest(NewTestID, 1);
          await(TModalResult, fStudentTest.Execute);
        finally
          if FChybneOtazky <> '' then
          begin
                // 🚀 ASYNCHRÓNNE VYHODÍME OKNO S TROMI GOMBÍKMI:
                // mtConfirmation hodí peknú ikonu, [mbYes, mbNo, mbCancel] vyrobí 3 gombíky
  // 🚀 JEDINÝ SPRÁVNY ASYNCHRÓNNY ZÁPIS PRE TMS WEB CORE:
  ZvolenaVolba := await(MessageDlgAsync(
    'Čo chcete urobiť ?'#13#10'👉 PONECHAŤ všetky doterajšie chybné (Kliknite na [ÁNO / YES])'#13#10'👉 ZMENIŤ na nové chybné otázky (Kliknite na [NIE / NO])'#13#10'❌ ZRUŠIŤ akciu (Kliknite na [ZRUŠIŤ / CANCEL])',
    mtConfirmation, [mbYes, mbNo, mbCancel]));

//                  ZvolenaVolba := await(TModalResult, MessageDlg('Opakovať všetky chybné alebo len posledné chybné alebo neopakujeme ?',
//                                       mtConfirmation, [mbYes, mbNo, mbCancel], 0));
                // 🎯 VYHODNOTENIE, NA ČO ŠTUDENT KLIKOL:
               case ZvolenaVolba of
                mrYes:
                begin
                // 🟢 PONECHAŤ (Študent klikol na "Yes" / Áno)
                //ShowMessage('Zvolili ste: Ponechať pôvodné otázky.');
                // ... sem vložíš tvoj kód pre ponechanie ...
                end;
                mrNo:
                begin
                // 🔵 ZMENIŤ (Študent klikol na "No" / Nie)
                //ShowMessage('Zvolili ste: Zmeniť otázky.');
                FChybneOtazky := fStudentTest.textChyb;
                end;
                mrCancel:
                begin
                // 🔴 ZRUŠIŤ (Študent klikol na "Cancel" / Zrušiť)
                //ShowMessage('Akcia bola zrušená.');
                FChybneOtazky := ''; // Úplne vyskočíme z procedúry, nič sa nedeje
                end;
               end;

          end else FChybneOtazky := fStudentTest.textChyb;

          fStudentTest.Free;
        end;

           btnOpakovatBio.Visible := False;
           btnOpakovatChem.Visible := False;
          if FChybneOtazky <> '' then
           btnOpakovatBio.Visible := True;



      finally
        JSONRes.Free;
      end;
    end;
  finally
    Req.Free;
  end;
end;


procedure TfHlavny.SpustiOpravneKolo(const APredmet: string; AButtonToHide: TSpeedButton);
var
  Req: THttpRequest;
  res: TJSXMLHttpRequest;
  JS: TJSONObject;
  JA: TJSONArray;
  CistyJsonText, FilterPayload: string;
  JSONRes: TJSONObject;
  NewTestID: Integer;
  ZvolenaVolba: TModalResult;
begin
  AButtonToHide.Visible := False; // Skryjeme tlačidlo, ktoré študent stlačil
  JS := TJSONObject.Create;
  JS.AddPair('student_id', 1);
  JS.AddPair('predmet', APredmet); // Dynamicky dosadí 'Biologia' alebo 'Chemia'

  JS.AddPair('od_cisla', 0);
  JS.AddPair('do_cisla', 0);

  if rgPocetOdpovedi.ItemIndex >= 0 then
    JS.AddPair('pocet_odpovedi', rgPocetOdpovedi.ItemIndex + 2)
  else
    JS.AddPair('pocet_odpovedi', 8); // Bezpečná poistka, ak by nebolo kliknuté nič



  JS.AddPair('chybne_otazky', FChybneOtazky);
  JA := TJSONArray.Create;
  JS.AddPair('okruhy', JA);
  FilterPayload := JS.ToString;
  JS.Free;
  Req := THttpRequest.Create(nil);
  try
    Req.Command := httpPOST;
    Req.URL := 'http://' + window.location.hostname + ':8080/inicializujtest';
    asm
      var utf8Bytes = encodeURIComponent(FilterPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
      Req.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, Req.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      asm
        var binaryString = atob(res.responseText);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      JSONRes := TJSONObject.ParseJSONValue(CistyJsonText) as TJSONObject;
      try
        NewTestID := StrToInt(JSONRes.Values['test_id'].Value);
        fStudentTest := TfStudentTest.Create(Self);
        try
          fStudentTest.Popup := False;
          fStudentTest.Border := fbNone;
          await(TfStudentTest, fStudentTest.Load);
          if JSONRes.Values['max_otazok'] <> nil then
            fStudentTest.FMaxOtazok := StrToInt(JSONRes.Values['max_otazok'].Value)
          else
            fStudentTest.FMaxOtazok := 0;
          fStudentTest.OtvorTest(NewTestID, 1);
          await(TModalResult, fStudentTest.Execute);
        finally
          if FChybneOtazky <> '' then
          begin
                // 🚀 ASYNCHRÓNNE VYHODÍME OKNO S TROMI GOMBÍKMI:
                // mtConfirmation hodí peknú ikonu, [mbYes, mbNo, mbCancel] vyrobí 3 gombíky
  // 🚀 JEDINÝ SPRÁVNY ASYNCHRÓNNY ZÁPIS PRE TMS WEB CORE:
  ZvolenaVolba := await(MessageDlgAsync(
    'Čo chcete urobiť ?'#13#10'👉 PONECHAŤ všetky doterajšie chybné (Kliknite na [ÁNO / YES])'#13#10'👉 ZMENIŤ na nové chybné otázky (Kliknite na [NIE / NO])'#13#10'❌ ZRUŠIŤ akciu (Kliknite na [ZRUŠIŤ / CANCEL])',
    mtConfirmation, [mbYes, mbNo, mbCancel]));

//                  ZvolenaVolba := await(TModalResult, MessageDlg('Opakovať všetky chybné alebo len posledné chybné alebo neopakujeme ?',
//                                       mtConfirmation, [mbYes, mbNo, mbCancel], 0));
                // 🎯 VYHODNOTENIE, NA ČO ŠTUDENT KLIKOL:
               case ZvolenaVolba of
                mrYes:
                begin
                // 🟢 PONECHAŤ (Študent klikol na "Yes" / Áno)
                //ShowMessage('Zvolili ste: Ponechať pôvodné otázky.');
                // ... sem vložíš tvoj kód pre ponechanie ...
                end;
                mrNo:
                begin
                // 🔵 ZMENIŤ (Študent klikol na "No" / Nie)
                //ShowMessage('Zvolili ste: Zmeniť otázky.');
                FChybneOtazky := fStudentTest.textChyb;
                end;
                mrCancel:
                begin
                // 🔴 ZRUŠIŤ (Študent klikol na "Cancel" / Zrušiť)
                //ShowMessage('Akcia bola zrušená.');
                FChybneOtazky := ''; // Úplne vyskočíme z procedúry, nič sa nedeje
                end;
               end;

          end else FChybneOtazky := fStudentTest.textChyb;



          fStudentTest.Free;
        end;
        // Ak spravil chyby aj v opravnom kole, tlačidlo sa znova rozsvieti

           btnOpakovatBio.Visible := False;
           btnOpakovatChem.Visible := False;

        if (FChybneOtazky <> '') then
          AButtonToHide.Visible := True;
      finally
        JSONRes.Free;
      end;
    end;
  finally
    Req.Free;
  end;
end;



procedure TfHlavny.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  btnBiologia := TSpeedButton.Create(Self);
  btnChemia := TSpeedButton.Create(Self);
  btnTestBio := TSpeedButton.Create(Self);
  btnTestChe := TSpeedButton.Create(Self);
  chkOkruh1 := TCheckBox.Create(Self);
  chkOkruh2 := TCheckBox.Create(Self);
  chkOkruh3 := TCheckBox.Create(Self);
  chkOkruh4 := TCheckBox.Create(Self);
  chkOkruh5 := TCheckBox.Create(Self);
  chkOkruh6 := TCheckBox.Create(Self);
  chkOkruh7 := TCheckBox.Create(Self);
  chkOkruh8 := TCheckBox.Create(Self);
  chkOkruh9 := TCheckBox.Create(Self);
  chkOkruh10 := TCheckBox.Create(Self);
  chkOkruh11 := TCheckBox.Create(Self);
  chkOkruh12 := TCheckBox.Create(Self);
  chkOkruh13 := TCheckBox.Create(Self);
  chkOkruh14 := TCheckBox.Create(Self);
  chkOkruh15 := TCheckBox.Create(Self);
  edtOd := TEdit.Create(Self);
  edtDo := TEdit.Create(Self);
  btnVynulovatRozsah := TSpeedButton.Create(Self);
  btnOpakovatBio := TSpeedButton.Create(Self);
  btnOpakovatChem := TSpeedButton.Create(Self);
  rgPocetOdpovedi := TRadioGroup.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  btnBiologia.BeforeLoadDFMValues;
  btnChemia.BeforeLoadDFMValues;
  btnTestBio.BeforeLoadDFMValues;
  btnTestChe.BeforeLoadDFMValues;
  chkOkruh1.BeforeLoadDFMValues;
  chkOkruh2.BeforeLoadDFMValues;
  chkOkruh3.BeforeLoadDFMValues;
  chkOkruh4.BeforeLoadDFMValues;
  chkOkruh5.BeforeLoadDFMValues;
  chkOkruh6.BeforeLoadDFMValues;
  chkOkruh7.BeforeLoadDFMValues;
  chkOkruh8.BeforeLoadDFMValues;
  chkOkruh9.BeforeLoadDFMValues;
  chkOkruh10.BeforeLoadDFMValues;
  chkOkruh11.BeforeLoadDFMValues;
  chkOkruh12.BeforeLoadDFMValues;
  chkOkruh13.BeforeLoadDFMValues;
  chkOkruh14.BeforeLoadDFMValues;
  chkOkruh15.BeforeLoadDFMValues;
  edtOd.BeforeLoadDFMValues;
  edtDo.BeforeLoadDFMValues;
  btnVynulovatRozsah.BeforeLoadDFMValues;
  btnOpakovatBio.BeforeLoadDFMValues;
  btnOpakovatChem.BeforeLoadDFMValues;
  rgPocetOdpovedi.BeforeLoadDFMValues;
  try
    Name := 'fHlavny';
    Width := 1101;
    Height := 480;
    Color := 16763647;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 248;
    WebLabel1.Top := 320;
    WebLabel1.Width := 89;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'alebo od ot'#225'zky :';
    WebLabel1.Color := 16763647;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 502;
    WebLabel2.Top := 320;
    WebLabel2.Width := 57;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'do ot'#225'zky :';
    WebLabel2.Color := 16763647;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    btnBiologia.SetParentComponent(Self);
    btnBiologia.Name := 'btnBiologia';
    btnBiologia.Left := 40;
    btnBiologia.Top := 32;
    btnBiologia.Width := 153;
    btnBiologia.Height := 49;
    btnBiologia.Caption := 'BIOL'#211'GIA';
    btnBiologia.Color := 16765066;
    btnBiologia.HeightPercent := 100.000000000000000000;
    btnBiologia.TabOrder := 0;
    btnBiologia.WidthPercent := 100.000000000000000000;
    SetEvent(btnBiologia, Self, 'OnClick', 'btnBiologiaClick');
    btnChemia.SetParentComponent(Self);
    btnChemia.Name := 'btnChemia';
    btnChemia.Left := 40;
    btnChemia.Top := 103;
    btnChemia.Width := 153;
    btnChemia.Height := 49;
    btnChemia.Caption := 'CH'#201'MIA';
    btnChemia.Color := 16765066;
    btnChemia.HeightPercent := 100.000000000000000000;
    btnChemia.TabOrder := 1;
    btnChemia.WidthPercent := 100.000000000000000000;
    SetEvent(btnChemia, Self, 'OnClick', 'btnChemiaClick');
    btnTestBio.SetParentComponent(Self);
    btnTestBio.Name := 'btnTestBio';
    btnTestBio.Left := 40;
    btnTestBio.Top := 216;
    btnTestBio.Width := 153;
    btnTestBio.Height := 49;
    btnTestBio.Caption := 'TEST BIOL'#211'GIA';
    btnTestBio.Color := 16765066;
    btnTestBio.HeightPercent := 100.000000000000000000;
    btnTestBio.TabOrder := 2;
    btnTestBio.WidthPercent := 100.000000000000000000;
    SetEvent(btnTestBio, Self, 'OnClick', 'btnTestBioClick');
    btnTestChe.SetParentComponent(Self);
    btnTestChe.Name := 'btnTestChe';
    btnTestChe.Left := 40;
    btnTestChe.Top := 286;
    btnTestChe.Width := 153;
    btnTestChe.Height := 49;
    btnTestChe.Caption := 'TEST CH'#201'MIA';
    btnTestChe.Color := 16765066;
    btnTestChe.HeightPercent := 100.000000000000000000;
    btnTestChe.TabOrder := 3;
    btnTestChe.WidthPercent := 100.000000000000000000;
    SetEvent(btnTestChe, Self, 'OnClick', 'btnTestCheClick');
    chkOkruh1.SetParentComponent(Self);
    chkOkruh1.Name := 'chkOkruh1';
    chkOkruh1.Left := 248;
    chkOkruh1.Top := 215;
    chkOkruh1.Width := 113;
    chkOkruh1.Height := 22;
    chkOkruh1.Caption := '001-100';
    chkOkruh1.ChildOrder := 4;
    chkOkruh1.HeightPercent := 100.000000000000000000;
    chkOkruh1.WidthPercent := 100.000000000000000000;
    chkOkruh2.SetParentComponent(Self);
    chkOkruh2.Name := 'chkOkruh2';
    chkOkruh2.Left := 369;
    chkOkruh2.Top := 215;
    chkOkruh2.Width := 113;
    chkOkruh2.Height := 22;
    chkOkruh2.Caption := '101-200';
    chkOkruh2.ChildOrder := 4;
    chkOkruh2.HeightPercent := 100.000000000000000000;
    chkOkruh2.WidthPercent := 100.000000000000000000;
    chkOkruh3.SetParentComponent(Self);
    chkOkruh3.Name := 'chkOkruh3';
    chkOkruh3.Left := 502;
    chkOkruh3.Top := 215;
    chkOkruh3.Width := 113;
    chkOkruh3.Height := 22;
    chkOkruh3.Caption := '201-300';
    chkOkruh3.ChildOrder := 4;
    chkOkruh3.HeightPercent := 100.000000000000000000;
    chkOkruh3.WidthPercent := 100.000000000000000000;
    chkOkruh4.SetParentComponent(Self);
    chkOkruh4.Name := 'chkOkruh4';
    chkOkruh4.Left := 623;
    chkOkruh4.Top := 215;
    chkOkruh4.Width := 113;
    chkOkruh4.Height := 22;
    chkOkruh4.Caption := '301-400';
    chkOkruh4.ChildOrder := 4;
    chkOkruh4.HeightPercent := 100.000000000000000000;
    chkOkruh4.WidthPercent := 100.000000000000000000;
    chkOkruh5.SetParentComponent(Self);
    chkOkruh5.Name := 'chkOkruh5';
    chkOkruh5.Left := 755;
    chkOkruh5.Top := 215;
    chkOkruh5.Width := 113;
    chkOkruh5.Height := 22;
    chkOkruh5.Caption := '401-500';
    chkOkruh5.ChildOrder := 4;
    chkOkruh5.HeightPercent := 100.000000000000000000;
    chkOkruh5.WidthPercent := 100.000000000000000000;
    chkOkruh6.SetParentComponent(Self);
    chkOkruh6.Name := 'chkOkruh6';
    chkOkruh6.Left := 248;
    chkOkruh6.Top := 243;
    chkOkruh6.Width := 113;
    chkOkruh6.Height := 22;
    chkOkruh6.Caption := '501-600';
    chkOkruh6.ChildOrder := 4;
    chkOkruh6.HeightPercent := 100.000000000000000000;
    chkOkruh6.WidthPercent := 100.000000000000000000;
    chkOkruh7.SetParentComponent(Self);
    chkOkruh7.Name := 'chkOkruh7';
    chkOkruh7.Left := 369;
    chkOkruh7.Top := 243;
    chkOkruh7.Width := 113;
    chkOkruh7.Height := 22;
    chkOkruh7.Caption := '601-700';
    chkOkruh7.ChildOrder := 4;
    chkOkruh7.HeightPercent := 100.000000000000000000;
    chkOkruh7.WidthPercent := 100.000000000000000000;
    chkOkruh8.SetParentComponent(Self);
    chkOkruh8.Name := 'chkOkruh8';
    chkOkruh8.Left := 502;
    chkOkruh8.Top := 243;
    chkOkruh8.Width := 113;
    chkOkruh8.Height := 22;
    chkOkruh8.Caption := '701-800';
    chkOkruh8.ChildOrder := 4;
    chkOkruh8.HeightPercent := 100.000000000000000000;
    chkOkruh8.WidthPercent := 100.000000000000000000;
    chkOkruh9.SetParentComponent(Self);
    chkOkruh9.Name := 'chkOkruh9';
    chkOkruh9.Left := 623;
    chkOkruh9.Top := 243;
    chkOkruh9.Width := 113;
    chkOkruh9.Height := 22;
    chkOkruh9.Caption := '801-900';
    chkOkruh9.ChildOrder := 4;
    chkOkruh9.HeightPercent := 100.000000000000000000;
    chkOkruh9.WidthPercent := 100.000000000000000000;
    chkOkruh10.SetParentComponent(Self);
    chkOkruh10.Name := 'chkOkruh10';
    chkOkruh10.Left := 755;
    chkOkruh10.Top := 243;
    chkOkruh10.Width := 113;
    chkOkruh10.Height := 22;
    chkOkruh10.Caption := '901-1000';
    chkOkruh10.ChildOrder := 4;
    chkOkruh10.HeightPercent := 100.000000000000000000;
    chkOkruh10.WidthPercent := 100.000000000000000000;
    chkOkruh11.SetParentComponent(Self);
    chkOkruh11.Name := 'chkOkruh11';
    chkOkruh11.Left := 248;
    chkOkruh11.Top := 271;
    chkOkruh11.Width := 113;
    chkOkruh11.Height := 22;
    chkOkruh11.Caption := '1001-1100';
    chkOkruh11.ChildOrder := 4;
    chkOkruh11.HeightPercent := 100.000000000000000000;
    chkOkruh11.WidthPercent := 100.000000000000000000;
    chkOkruh12.SetParentComponent(Self);
    chkOkruh12.Name := 'chkOkruh12';
    chkOkruh12.Left := 369;
    chkOkruh12.Top := 271;
    chkOkruh12.Width := 113;
    chkOkruh12.Height := 22;
    chkOkruh12.Caption := '1101-1200';
    chkOkruh12.ChildOrder := 4;
    chkOkruh12.HeightPercent := 100.000000000000000000;
    chkOkruh12.WidthPercent := 100.000000000000000000;
    chkOkruh13.SetParentComponent(Self);
    chkOkruh13.Name := 'chkOkruh13';
    chkOkruh13.Left := 502;
    chkOkruh13.Top := 271;
    chkOkruh13.Width := 113;
    chkOkruh13.Height := 22;
    chkOkruh13.Caption := '1201-1300';
    chkOkruh13.ChildOrder := 4;
    chkOkruh13.HeightPercent := 100.000000000000000000;
    chkOkruh13.WidthPercent := 100.000000000000000000;
    chkOkruh14.SetParentComponent(Self);
    chkOkruh14.Name := 'chkOkruh14';
    chkOkruh14.Left := 623;
    chkOkruh14.Top := 271;
    chkOkruh14.Width := 113;
    chkOkruh14.Height := 22;
    chkOkruh14.Caption := '1301-1400';
    chkOkruh14.ChildOrder := 4;
    chkOkruh14.HeightPercent := 100.000000000000000000;
    chkOkruh14.WidthPercent := 100.000000000000000000;
    chkOkruh15.SetParentComponent(Self);
    chkOkruh15.Name := 'chkOkruh15';
    chkOkruh15.Left := 755;
    chkOkruh15.Top := 271;
    chkOkruh15.Width := 113;
    chkOkruh15.Height := 22;
    chkOkruh15.Caption := '1401-1500';
    chkOkruh15.ChildOrder := 4;
    chkOkruh15.HeightPercent := 100.000000000000000000;
    chkOkruh15.WidthPercent := 100.000000000000000000;
    edtOd.SetParentComponent(Self);
    edtOd.Name := 'edtOd';
    edtOd.Left := 353;
    edtOd.Top := 317;
    edtOd.Width := 121;
    edtOd.Height := 22;
    edtOd.ChildOrder := 19;
    edtOd.HeightPercent := 100.000000000000000000;
    edtOd.WidthPercent := 100.000000000000000000;
    SetEvent(edtOd, Self, 'OnKeyPress', 'edtOdKeyPress');
    edtDo.SetParentComponent(Self);
    edtDo.Name := 'edtDo';
    edtDo.Left := 577;
    edtDo.Top := 317;
    edtDo.Width := 121;
    edtDo.Height := 22;
    edtDo.ChildOrder := 19;
    edtDo.HeightPercent := 100.000000000000000000;
    edtDo.TabOrder := 1;
    edtDo.WidthPercent := 100.000000000000000000;
    SetEvent(edtDo, Self, 'OnKeyPress', 'edtDoKeyPress');
    btnVynulovatRozsah.SetParentComponent(Self);
    btnVynulovatRozsah.Name := 'btnVynulovatRozsah';
    btnVynulovatRozsah.Left := 744;
    btnVynulovatRozsah.Top := 317;
    btnVynulovatRozsah.Width := 116;
    btnVynulovatRozsah.Height := 22;
    btnVynulovatRozsah.Caption := 'Vynulova'#357' rozsah';
    btnVynulovatRozsah.Color := clNone;
    btnVynulovatRozsah.HeightPercent := 100.000000000000000000;
    btnVynulovatRozsah.TabOrder := 21;
    btnVynulovatRozsah.WidthPercent := 100.000000000000000000;
    SetEvent(btnVynulovatRozsah, Self, 'OnClick', 'btnVynulovatRozsahClick');
    btnOpakovatBio.SetParentComponent(Self);
    btnOpakovatBio.Name := 'btnOpakovatBio';
    btnOpakovatBio.Left := 40;
    btnOpakovatBio.Top := 359;
    btnOpakovatBio.Width := 153;
    btnOpakovatBio.Height := 49;
    btnOpakovatBio.Caption := 'OPAKOVA'#268'KA BIO';
    btnOpakovatBio.Color := 16765066;
    btnOpakovatBio.HeightPercent := 100.000000000000000000;
    btnOpakovatBio.TabOrder := 22;
    btnOpakovatBio.Visible := False;
    btnOpakovatBio.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpakovatBio, Self, 'OnClick', 'btnOpakovatBioClick');
    btnOpakovatChem.SetParentComponent(Self);
    btnOpakovatChem.Name := 'btnOpakovatChem';
    btnOpakovatChem.Left := 40;
    btnOpakovatChem.Top := 414;
    btnOpakovatChem.Width := 153;
    btnOpakovatChem.Height := 49;
    btnOpakovatChem.Caption := 'OPAKOVA'#268'KA CHEMIA';
    btnOpakovatChem.Color := 16765066;
    btnOpakovatChem.HeightPercent := 100.000000000000000000;
    btnOpakovatChem.TabOrder := 23;
    btnOpakovatChem.Visible := False;
    btnOpakovatChem.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpakovatChem, Self, 'OnClick', 'btnOpakovatChemClick');
    rgPocetOdpovedi.SetParentComponent(Self);
    rgPocetOdpovedi.Name := 'rgPocetOdpovedi';
    rgPocetOdpovedi.Left := 272;
    rgPocetOdpovedi.Top := 40;
    rgPocetOdpovedi.Width := 545;
    rgPocetOdpovedi.Height := 112;
    rgPocetOdpovedi.Caption := ' Po'#269'et odpoved'#237' ';
    rgPocetOdpovedi.ChildOrder := 26;
    rgPocetOdpovedi.Columns := 7;
    rgPocetOdpovedi.Font.Charset := DEFAULT_CHARSET;
    rgPocetOdpovedi.Font.Color := clWindowText;
    rgPocetOdpovedi.Font.Height := -15;
    rgPocetOdpovedi.Font.Name := 'Segoe UI';
    rgPocetOdpovedi.Font.Style := [];
    rgPocetOdpovedi.ItemIndex := 6;
    rgPocetOdpovedi.Items.BeginUpdate;
    try
      rgPocetOdpovedi.Items.Clear;
      rgPocetOdpovedi.Items.Add('2');
      rgPocetOdpovedi.Items.Add('3');
      rgPocetOdpovedi.Items.Add('4');
      rgPocetOdpovedi.Items.Add('5');
      rgPocetOdpovedi.Items.Add('6');
      rgPocetOdpovedi.Items.Add('7');
      rgPocetOdpovedi.Items.Add('8');
    finally
      rgPocetOdpovedi.Items.EndUpdate;
    end;
    rgPocetOdpovedi.ParentFont := False;
    rgPocetOdpovedi.Role := '';
    rgPocetOdpovedi.TabOrder := 24;
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    btnBiologia.AfterLoadDFMValues;
    btnChemia.AfterLoadDFMValues;
    btnTestBio.AfterLoadDFMValues;
    btnTestChe.AfterLoadDFMValues;
    chkOkruh1.AfterLoadDFMValues;
    chkOkruh2.AfterLoadDFMValues;
    chkOkruh3.AfterLoadDFMValues;
    chkOkruh4.AfterLoadDFMValues;
    chkOkruh5.AfterLoadDFMValues;
    chkOkruh6.AfterLoadDFMValues;
    chkOkruh7.AfterLoadDFMValues;
    chkOkruh8.AfterLoadDFMValues;
    chkOkruh9.AfterLoadDFMValues;
    chkOkruh10.AfterLoadDFMValues;
    chkOkruh11.AfterLoadDFMValues;
    chkOkruh12.AfterLoadDFMValues;
    chkOkruh13.AfterLoadDFMValues;
    chkOkruh14.AfterLoadDFMValues;
    chkOkruh15.AfterLoadDFMValues;
    edtOd.AfterLoadDFMValues;
    edtDo.AfterLoadDFMValues;
    btnVynulovatRozsah.AfterLoadDFMValues;
    btnOpakovatBio.AfterLoadDFMValues;
    btnOpakovatChem.AfterLoadDFMValues;
    rgPocetOdpovedi.AfterLoadDFMValues;
  end;
end;

end.
